import { httpApi } from '@app/api/http.api'

export type InverterRequest = {
  name: string
  type: string
  manufacturer: string
  code: string
  errors?: InvertersError[] | []
}

export type GetInverterResponse = {
  id: string
  name: string
  type: string
  manufacturer: string
  code: string
  isDeleted: boolean
  createdAt: Date
  updatedAt: Date
  errorsList: any[]
}

export type InvertersError = {
  id?: string
  error_id: string
  description: string
  solution_steps?: string
  language: string
}

export type InvertersToDevice = {
  id: string
  deviceId: string
  inverterId: string
  dataType: string
  index: string
  messageId: string | null
  bitIndex: string | null
  createdAt: Date
  updatedAt: Date
}

export type InverterToDeviceWithInverterWithErrors = {
  inverterToDevice: InvertersToDevice
  inverter: GetInverterResponse
}

export type DeviceErrorDetails = {
  createdAt: Date
  resolvedDate: Date | null
  confirmedDate: Date | null
  inverterDeviceConnection?: {
    dataType: string
    index: number
    mechanism: string
  }
  inverterErrorDetails: {
    id: string
    language: string
    value: string
    description: string
    solution: string
  }[]
}

const INVERTERS = 'inverters'

export const getInverter = (id: string): Promise<GetInverterResponse> =>
  httpApi.get<GetInverterResponse>(`${INVERTERS}/${id}`).then(({ data }) => data)

export const getAllInverters = (): Promise<GetInverterResponse[]> =>
  httpApi.get<GetInverterResponse[]>(`${INVERTERS}/all`).then(({ data }) => data)

export const createInverter = (createInverterPayload: InverterRequest): Promise<GetInverterResponse> =>
  httpApi
    .post<GetInverterResponse>(`${INVERTERS}/create-inverter`, { ...createInverterPayload })
    .then(({ data }) => data)

export const updateInverter = (id: string, updateInverterPayload: InverterRequest): Promise<GetInverterResponse> =>
  httpApi
    .put<GetInverterResponse>(`${INVERTERS}/update-inverter/${id}`, { ...updateInverterPayload })
    .then(({ data }) => data)

export const deleteInverter = (id: string): Promise<GetInverterResponse> =>
  httpApi.delete<GetInverterResponse>(`${INVERTERS}/${id}`).then(({ data }) => data)

export const getDeviceErrorDetails = (id: string, language: string): Promise<DeviceErrorDetails> =>
  httpApi.get<DeviceErrorDetails>(`${INVERTERS}/error-details/${id}`, { params: { language } }).then(({ data }) => data)
